module.exports = __webpack_public_path__ + "static/media/favicon.6d3d4d87.png";